<template>
  <div>
    <!--start location picker modal -->
<div class="modal fade" id="LocationPickerModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="locationPickerLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-introduction rounded-3 padding-bottom-2">
      <div class="modal-header pb-0 border-bottom-0 padding-top-3 w-100 d-inline-block padding-left-3 padding-right-3">
        <p class="text-black mb-0 medium-family float-start text-size-14 text-full-14" id="locationPickerLabel">Select Location</p>
        <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" @click="closeModal('LocationPickerModal')" aria-label="Close"></button>
      </div>
      <div class="modal-body padding-2 position-relative">
        <!-- Location Search Input -->
        <div class="w-100 d-inline-block margin-top-2 position-relative">
          <div class="row">
            <div class="col-xl-10 col-12">
               <form class="position-relative booking-banner" @submit.prevent>
                  <input
                    type="text"
                    v-model="searchQuery"
                    @input="handleInput"
                    placeholder="Search for area, street name, landmark..."
                    class="bg-white box-shadow rounded-3 border-0 text-size-16 text-full-13 w-100"
                  />
                  <a class="position-absolute location-icon" href="javascript:void(0)">
                    <img v-lazy="require('@/assets/images/location-service-icon.svg')" alt="Location icon">
                  </a>
                  <i class="fa fa-angle-down position-absolute nav-color angle-right-icon" aria-hidden="true"></i>
              </form>
            </div>
            <div class="col-xl-2 col-12 mt-xl-0 mt-3 
            ps-xl-0">
              <div class="text-end margin-top-2">
                <button
                  type="button"
                  class="btn btn-success px-4 py-2 text-white text-size-14 rounded-3 text-full-14"
                  @click="confirmLocation"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
          <!-- Predictions Dropdown -->
          <div v-if="predictions.length" class="predictions-container position-absolute w-100 margin-top-1 z-3">
            <div 
              v-for="(suggestion, index) in predictions" 
              :key="index"
              class="prediction-item padding-2 text-start bg-white border-bottom cursor-pointer text-full-13 text-size-14"
              @click="selectSuggestion(suggestion)"
            >
              {{ suggestion.description }}
            </div>
          </div>
        </div>

        <!-- Map Section -->
        <!-- <div class="w-100 d-inline-block margin-top-3 rounded-3 overflow-hidden" style="height: 400px;">
          <div id="map" style="width: 100%; height: 100%;"></div>
        </div> -->
        <div class="w-100 d-inline-block map-scroll">
        <div class="w-100 d-inline-block margin-top-3 rounded-3 confirm-location-map">
          <div id="map" style="width: 100%; height: 100%;">
          </div>
          <div v-if="!locationConfirmed" class="position-absolute start-50 translate-middle text-center text-white bg-dark bg-opacity-75 rounded-2"
          style="width: 310px; top: 75%; padding:0 1rem !important;" >
            Move the map to set the exact position
          </div>
        </div>
      </div>
        <div v-if="locationConfirmed" class="w-100 d-inline-block confirm-location-btn">
            <button
              type="button"
              class="btn bg-green px-4 py-2 text-white text-size-14 rounded-3 text-full-14 w-100 d-inline-block"
              @click="confirmPinLocation"
            >
              Confirm Pin Location
            </button>
          </div>
          <div v-else class="w-100 d-inline-block confirm-location-btn">
            <button
              type="button"
              class="btn bg-green px-4 py-2 text-white text-size-14 rounded-3 text-full-14 w-100 d-inline-block disabled"
              @click="confirmPinLocation"
            >
              Confirm Pin Location
            </button>
          </div>
        <!-- Place the button right after the map div -->
      </div>
    </div>
  </div>
</div>
<!--end location picker modal -->
<div class="w-100 d-inline-block bg-book-banner-image pb-3">
      <div class="container autoContent">
        <div class="row margin-top-3 margin-bottom-3">
          <div class="col-12 margin-top-2">
            <div class="w-50 d-block text-center m-auto booking-banner position-relative w-xs-100 w-sm-100 w-md-70 w-ipad-55">
              <h1 class="text-black fw-bold text-full-24 filson-black-family margin-bottom-2 text-size-24">
                Make Your Pet's Life Easier with Dubai Pet Grooming Services
              </h1>
              <p class="mb-0 text-size-14 text-black inter-regular-family text-full-13">
                Where would you like to receive your service?
              </p>
              <form class="position-relative" @submit.prevent>
                <input
                  v-model="cartAddress"
                  @click="initMap"
                  class="bg-white box-shadow rounded-3 border-0 text-size-16 margin-top-2 w-100 text-full-13"
                  type="text"
                  placeholder="Search for area, street name, landmark..."
                />
                <a class="position-absolute location-icon" @click="initMap" href="javascript:void(0)">
                  <img v-lazy="require('@/assets/images/location-service-icon.svg')" alt="Location icon">
                </a>
                <i class="fa fa-angle-down position-absolute nav-color angle-right-icon" aria-hidden="true"></i>
              </form>
              <!-- Add predictions dropdown -->
              <!-- <div v-if="predictions.length" ref="predictionsContainer" class="predictions-container position-absolute w-100 margin-top-1">
                <div 
                  v-for="prediction in predictions" 
                  :key="prediction.place_id"
                  class="prediction-item padding-2 text-start bg-white border-bottom cursor-pointer text-full-13 text-size-14"
                  @click="selectPrediction(prediction)"
                >
                  {{ prediction.description }}
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->
    <div class="w-100 d-inline-block bg-book-detail-image position-relative">
      <div class="container autoContent">
        <div class="row margin-top-3">
          <div class="col-12 col-xl-9 mb-xl-0 mb-2 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block active-detail-box">
              <div
                class="d-inline-block detail-card-box text-center w-19 bg-introduction rounded-3"
                @click="isFirstDivVisible = true; isSecondDivVisible = false;"
              >
                <a class="text-black text-size-14 rounded-2 d-inline-block w-100 inter-bold-family text-full-12" href="javascript:void(0)" :class="{'activebox': activeLink === 'all'}" @click="setActiveLink('all'); filterCategories('all')">
                  <span class="d-inline-block margin-top-2">
                    <!-- <img src="@/assets/images/all-service-icon.svg" alt="" /> -->
                    <img v-lazy="require('@/assets/images/all-service-icon.svg')" alt="">
                  </span>
                  <span class="d-inline-block w-100 margin-top-2 margin-bottom-2 text-full-11 text-size-14">
                    All
                  </span>
                </a>
              </div>
              <div v-for="category in categories" :key="category.id"
                class="d-inline-block detail-card-box text-center w-19 bg-introduction rounded-3"
                @click="isFirstDivVisible = true; isSecondDivVisible = false;"
              >
                <a class="text-black text-size-14 rounded-2 d-inline-block w-100 inter-bold-family text-full-12" href="javascript:void(0)" :class="{'activebox': activeLink === category.name}" @click="setActiveLink(category.name); filterCategories(category.id)">
                  <span class="d-inline-block margin-top-2">
                    <!-- <img :src="$getImageUrl(category.image)" :alt="category.name" /> -->
                    <img v-lazy="$getImageUrl(category.image)" :alt="category.name" />
                  </span>
                  <span class="d-inline-block w-100 margin-top-2 margin-bottom-2 text-full-11 text-size-14">
                  {{ category.name }}</span>
                </a>
              </div>
            </div>
            <div class="w-100 d-inline-block">
              <div class="row margin-top-3 row-scroll scroll-web padding-bottom-2">
                <div class="col-xl-4 col-6 col-md-6 col-lg-6 col-sm-6" v-for="plan in plans" :key="plan.id">
                  <div class="w-100 d-inline-block text-center">
                    <a class="text-black text-size-14 rounded-5 d-inline-block bg-introduction inter-bold-family w-100 text-uppercase padding-2 text-full-12" href="javascript:void(0)" @click="filterPlans(plan.id)" :class="{'activebasic': selectedPlanId === plan.id}">
                      <!-- <img class="margin-right-2 full-grooming-icon" src="@/assets/images/full-grooming-icon.svg" alt="" /> -->
                      <img class="margin-right-2 full-grooming-icon" v-lazy="require('@/assets/images/full-grooming-icon.svg')" alt="">
                      {{plan.name}}
                    </a>
                  </div>
                </div>
              </div>
              <div v-for="planDetailItem in planDetailsArray" :key="planDetailItem.id">
                <div class="w-100 d-inline-block bg-introduction padding-2 margin-top-2 rounded-4 position-relative overflow-hidden">
                  <!-- <img 
                    class="w-100 rounded-4" 
                    :src="$getImageUrl(planDetailItem.image)" 
                    :alt="planDetailItem.title"
                  /> -->
                  <img 
                    class="w-100 rounded-4" 
                    v-lazy="$getImageUrl(planDetailItem.image)" 
                    :alt="planDetailItem.title"
                  />

                  <p class="text-white text-size-18 w-100 fw-bold filson-black-family text-full-24 position-absolute top-50 start-50 translate-middle text-center px-3 mb-0">
                    {{ planDetailItem.title }}
                  </p>
                </div>
                <div v-for="planDetail in planDetailItem.plan_detail_prices" :key="planDetail.id">
                  <div class="w-100 d-inline-block bg-introduction padding-2 rounded-4 margin-top-2">
                    <div class="w-100 d-inline-block bg-white rounded-2 padding-2">
                      <div class="row">
                        <div class="col-12 col-xl-3 mb-xl-0 mb-2 pe-xl-0">
                          <div class="w-100 d-inline-block plane-detail-image">
                            <!-- <img class="w-100 rounded-3" 
                              :src="$getImageUrl(planDetail.image)" 
                              :alt="planDetail.name" 
                            /> -->
                            <img class="w-100 rounded-3" 
                              v-lazy="$getImageUrl(planDetail.image)" 
                              :alt="planDetail.name" 
                            />
                          </div>
                        </div>
                        <div class="col-12 col-xl-9 mb-xl-0 mb-2">
                          <div class="w-100 d-inline-block border-bottom">
                            <h2 class="dark-black fw-bold text-size-14 margin-top-2 margin-bottom-2 medium-family text-full-14">
                              {{ planDetail.name }}
                            </h2>
                            <p class="dark-black text-size-14 margin-bottom-2 family-inter-light w-75 w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-full-12">
                              {{ planDetail.description }}
                            </p>
                          </div>
                          <div class="row margin-top-2">
                            <div class="col-12 col-xl-5 mb-xl-0 mb-2 pr-xs-0 col-md-3 col-lg-5 pe-md-0 mt-1">
                              <div class="float-start d-inline-block w-100 mt-xl-0 mt-0 mt-md-2 mt-lg-3">
                                <span class="dark-black fw-bold text-size-14 margin-right-2 inter-semi-bold text-full-13">
                                  AED {{ planDetail.price }}
                                </span>
                                <strike class="strike-text text-size-13 inter-semi-bold text-full-12">
                                  AED {{ planDetail.sale_price }}
                                </strike>
                              </div>
                            </div>
                            <div class="col-12 col-xl-7 mb-xl-0 mb-2 mt-xl-0 mt-2 col-md-9 col-lg-7">
                              <div class="float-xl-end direction-viewservice-btn">
                                <!-- View Services Button -->
                                <a 
                                  class="text-size-14 text-white d-inline-block bg-green rounded-5 inter-semi-bold text-uppercase me-xl-2 me-md-0 text-full-12 view-service-btn" 
                                  href="javascript:void(0)" 
                                  @click="fetchDataAndOpenModal(planDetail.id)">
                                  View Services
                                </a>
                                <!-- Add to Cart Button -->
                                <div class="float-end" v-if="!isInCart(planDetail.id)">
                                <a
                                  class="text-size-14 text-white d-inline-block bg-blue rounded-5 inter-semi-bold text-uppercase text-full-12 view-service-btn"
                                  href="javascript:void(0)"
                                  @click="addToCart(planDetail)">
                                  Add to Cart
                                </a>
                              </div>
                                <!-- Quantity Controls -->
                                <div v-else class="float-end">
                                  <a class="text-size-14 nav-color d-inline-block bg-white rounded-5 plus-minus-btn border-green w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-full-12" 
                                    href="javascript:void(0)">
                                    <span 
                                      class="btn-text text-size-14 margin-right-3 minus-icon text-full-12" 
                                      @click="decrement(planDetail.id)">
                                      <i class="fa fa-minus" aria-hidden="true"></i>
                                    </span>
                                    <span class="text-black fw-bold text-size-14 margin-right-3 number-icon text-full-12">
                                      {{ getCartItem(planDetail.id).count }}
                                    </span>
                                    <span 
                                      class="btn-text text-size-14 plus-icon rtl-mr-3 text-full-12"
                                      @click="increment(planDetail.id)">
                                      <i class="fa fa-plus" aria-hidden="true"></i>
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-3 mb-xl-0 mb-2 col-md-6 col-lg-6 d-xl-inline-block d-none d-md-block d-lg-block">
            <div class="w-100 d-inline-block bg-introduction rounded-3 padding-bottom-3 padding-2 booking-detail-box" style="position:sticky;top:8vw;">
              <p class="text-black text-size-14 mb-0 inter-semi-bold text-full-13">Booking Details</p>
              <div class="w-100 d-inline-block bg-white rounded-2 margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <div class="row">
                    <div class="col-xl-4 col-5 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">
                          Service
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-8 col-7 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-black medium-family text-full-11">
                          Dog, Cat Grooming
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-inline-block padding-2 booking-scroll">
                  <div class="row border-bottom padding-bottom-1">
                    <div class="col-xl-8 col-8 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">
                          Service Details
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-4 col-4 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <a href="javascript:void(0)" class="text-size-14 edit-text inter-bold-family text-full-11">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-for="(item, index) in cart" :key="index">
                  <div class="row border-bottom padding-bottom-1 padding-top-1">
                    <div class="col-xl-7 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 text-black medium-family text-full-11">
                          {{item.name}} ({{item.plan_detail.plan.name}})
                          <span class="text-green">x{{item.count}}</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-5 col-5 mb-xl-0 mb-2 ps-xl-0">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family text-full-11"> AED {{item.price * item.count}} 
                        </span>
                        <span class="text-size-14 text-red cursor-pointer ms-1 text-full-11" 
                        @click="removeItem(index)">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="w-100 d-inline-block rounded-3 bg-gallery margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <p class="text-size-14 text-black mb-0 medium-family text-full-12">
                    Payment Summary
                  </p>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <div class="row">
                    <div class="col-xl-6 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">Total</span>
                      </div>
                    </div>
                    <div class="col-xl-6 col-5 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family text-full-11">
                          AED {{ cartTotal }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block bg-white rounded-3 margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <p class="text-size-14 strike-text mb-0 medium-family text-full-12">
                    Address
                  </p>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <p class="text-size-14 dark-black mb-0 family-inter-light text-full-11 location-address">
                    {{ address }}
                  </p>
                </div>
              </div>
              <div class="w-100 d-inline-block margin-top-2 text-center">
                <!-- <a class="bg-green rounded-5 text-white d-inline-block p-1 w-100 inter-semi-bold text-size-14" href="/date">
                  Next
                </a> -->
                <!-- <router-link class="bg-green rounded-5 text-white d-inline-block p-1 w-100 inter-semi-bold text-size-14" to="/date">Next
              </router-link> -->
              <router-link 
                class="bg-green rounded-5 text-white d-inline-block padding-1 w-100 inter-semi-bold text-size-14 text-full-14 line-height-25"
                :to="''" 
                @click.prevent="checkCartAndProceed">
                Next
              </router-link>
              </div>
            </div>
            <div class="w-100 d-inline-block tab-cat-image margin-top-4">
              <img class="w-100" src="@/assets/images/tab-cat-image.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-introduction margin-top-3">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                  <i class="fa fa-home nav-color" aria-hidden="true"></i>
                  Home /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                  Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-xl-none d-block d-md-none d-lg-none sticky-booking-footer text-center bg-white box-shadow">
      <div class="container">
        <div class="row">
          <div class="col-6 mt-1">
            <div class="w-100 d-inline-block text-start ps-xl-0 ps-3" data-bs-toggle="modal" data-bs-target="#bookStickyBackdrop">
              <p class="mb-0 text-size-17 strike-text medium-family">
                Total
              </p>
              <span class="text-size-18 text-black medium-family fw-bold"> AED {{ cartTotal }} 
              </span>
              <span class="text-size-24 cursor-pointer ms-1">
                  <i class="fa fa-angle-up" aria-hidden="true"></i>
              </span>
            </div>
          </div>
          <div class="col-6 mt-2">
            <div class="w-100 d-inline-block">
              <router-link 
                class="bg-green rounded-5 text-white d-inline-block next-btn w-100 inter-semi-bold text-size-18 line-height-25"
                :to="''" 
                @click.prevent="checkCartAndProceed">
                Next
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--start book sticky modal -->
<div class="modal fade" id="bookStickyBackdrop" data-bs-backdrop="true" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header pb-0 border-bottom-0 padding-top-3 w-100 d-inline-block">
        <p class="text-black text-size-14 text-full-14 mb-0 medium-family float-start" id="staticBackdropLabel">Booking Details</p>
        <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div class="modal-body">
        <div class="w-100 d-inline-block bg-introduction rounded-3 padding-bottom-3 padding-2">
              <!-- <p class="text-black text-size-14 mb-0 inter-semi-bold text-full-13">Booking Details</p> -->
              <div class="w-100 d-inline-block bg-white rounded-2 margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <div class="row">
                    <div class="col-xl-4 col-5 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">
                          Service
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-8 col-7 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-black medium-family text-full-11">
                          Dog, Cat Grooming
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <div class="row border-bottom padding-bottom-1">
                    <div class="col-xl-6 col-8 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">
                          Service Details
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-6 col-4 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <a href="javascript:void(0)" class="text-size-14 edit-text inter-bold-family text-full-11">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-for="(item, index) in cart" :key="index">
                  <div class="row border-bottom padding-bottom-1 padding-top-1">
                    <div class="col-xl-7 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 text-black medium-family text-full-11">
                          {{item.name}} ({{item.plan_detail.plan.name}})
                          <span class="text-green">x{{item.count}}</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-5 col-5 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family text-full-11"> AED {{item.price * item.count}} 
                        </span>
                        <span class="text-size-14 text-red cursor-pointer ms-1 text-full-11" 
                        @click="removeItem(index)">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="w-100 d-inline-block rounded-3 bg-gallery margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <p class="text-size-14 text-black mb-0 medium-family text-full-12">
                    Payment Summary
                  </p>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <div class="row">
                    <div class="col-xl-6 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">Total</span>
                      </div>
                    </div>
                    <div class="col-xl-6 col-5 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family text-full-11">
                          AED {{ cartTotal }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block bg-white rounded-3 margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <p class="text-size-14 strike-text mb-0 medium-family text-full-12">
                    Address
                  </p>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <p class="text-size-14 dark-black mb-0 family-inter-light 
                  text-full-11">
                    {{ address }}
                  </p>
                </div>
              </div>
              <div class="w-100 d-inline-block margin-top-2 text-center mb-5">
                <!-- <a class="bg-green rounded-5 text-white d-inline-block p-1 w-100 inter-semi-bold text-size-14" href="/date">
                  Next
                </a> -->
                <!-- <router-link class="bg-green rounded-5 text-white d-inline-block p-1 w-100 inter-semi-bold text-size-14" to="/date">Next
              </router-link> -->
              <router-link 
                class="bg-green rounded-5 text-white d-inline-block padding-1 w-100 inter-semi-bold text-size-14 text-full-14 line-height-25 mb-4"
                :to="''" 
                @click.prevent="checkCartAndProceed">
                Next
              </router-link>
              </div>
            </div>
      </div>
    </div>
  </div>
</div>
<!--end book sticky modal -->

    <!--start add to card modal -->
    <div class="modal fade" id="AddToCArtModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content bg-introduction">
          <div class="modal-header pb-0 border-bottom-0 padding-top-3 w-100 d-inline-block">
            <p class="text-black text-size-14 text-full-14 mb-0 medium-family float-start">{{modalData.name}}</p>
            <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0"  @click="closeModal('AddToCArtModal')"  aria-label="Close"></button>
          </div>
          <div v-if="loading">Loading...</div>
        <div v-else-if="error">{{ error }}</div>
          <div v-else class="modal-body padding-1 
          pb-0">
            <div class="w-100 d-inline-block text-center">
              <!-- <img class="margin-top-2" :src="$getImageUrl(modalData.image_back)" :alt="modalData.name_back" /> -->
              <img
                class="margin-top-2"
                v-lazy="$getImageUrl(modalData.image_back)"
                :alt="modalData.name_back"
              />
            </div>
            <div class="w-100 d-inline-block bg-white rounded-3 margin-top-2 padding-2 margin-bottom-3">
              <div class="row margin-top-3">
                <div class="col-12 col-xl-8 mb-xl-0 mb-2 col-md-8 col-lg-8">
                  <div class="w-100 d-inline-block">
                    <p class="text-black text-size-14 mb-0 family-inter-light text-full-13">
                      {{modalData.description}}
                    </p>
                    <p class="text-black text-size-14 fw-bold margin-top-3 medium-family text-full-13 margin-bottom-3">Duration: {{modalData.duration}} mins</p>
                    <p class="text-black text-size-14 fw-bold margin-top-3 medium-family text-full-13 margin-bottom-3">
                      What is included:
                    </p>
                    <ul v-for="service in services"
                        :key="service.id" 
                        class="w-100 d-inline-block padding-left-3 mb-0 add-cart-menu">
                      <li>
                        <span class="text-black text-size-14 family-inter-light text-full-13">
                          <i class="fa fa-check-circle-o nav-color margin-right-2" aria-hidden="true"></i>
                          {{service.name}}
                        </span>
                      </li>
                    </ul>
                    <p class="text-black text-size-14 margin-top-3 family-inter-light text-full-13">
                      Note: Two professionals will only be assigned if available
                    </p>
                  </div>
                </div>
                <div class="col-12 col-xl-4 mb-xl-0 mb-2 col-md-4 col-lg-4">
  <div class="w-100 d-inline-block padding-2 bg-introduction rounded-3 text-center">
    <p class="fw-bold text-size-16 margin-top-2 mb-0 inter-semi-bold text-full-16">
      AED {{ modalData.price }}
    </p>
    <strike class="strike-text text-size-14 inter-semi-bold text-full-13">AED {{ modalData.sale_price }}</strike>

    <!-- Counter or Add to Cart -->
    <div class="w-100 d-inline-block margin-top-2 margin-bottom-2">
      <template v-if="isInCart(modalData.id)">
        <a
          class="text-size-14 text-green d-inline-block bg-white rounded-2 plus-minus-icon-btn border-green text-full-12" href="javascript:void(0)">
          <span class="btn-text text-size-14 margin-right-3 minus-icon text-full-12" @click="decrement(modalData.id)">
            <i class="fa fa-minus" aria-hidden="true"></i>
          </span>
          <span class="text-black fw-bold text-size-14 margin-right-3 number-icon text-full-12">
            {{ getCartItem(modalData.id).count }}
          </span>
          <span class="btn-text text-size-14 plus-icon text-full-12" @click="increment(modalData.id)">
            <i class="fa fa-plus" aria-hidden="true">
              
            </i>
          </span>
        </a>
      </template>
      <template v-else>
        <button
          type="button"
          class="btn d-inline-block text-size-14 bg-green w-100 padding-left-2 padding-right-2 rounded-5 inter-semi-bold text-white text-full-12"
          @click="addToCart(modalData)">
          ADD TO CART
        </button>
      </template>
    </div>
  </div>
</div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end add to card modal --> 
  </div>
</template>

<script>
/* global google */
  export default {
    name: "bookingDetailComponent",
    data() {
      return {
        locationConfirmed: false,
        searchQuery: '',
        predictions: [],
        address: '',
        categories: [],
        selectedPlanId: localStorage.getItem("selectedPlanId") || '',
        selectedCategoryId: localStorage.getItem("selectedPlanId") || '',
        planDetailsArray: [],
        isFirstDivVisible: false,
        isSecondDivVisible: true,
        isThirdDivVisible: false,
        isFourthDivVisible: false,
        isFiveDivVisible: false,
        activeLink: "all",
        activePlan: '',
        count: 0,
        services: [], // To hold the fetched data
        loading: false,
        error: null,
        modalData: [],
        cart: [],
        cartAddress:'',
      };
    },
    mounted() {
     
      this.fetchCategories();
      this.loadCart();
    },
    computed: {
    // Calculate the grand total by summing up the total of each item in the cart
    cartTotal() {
      return this.cart.reduce((total, item) => total + (item.price * item.count), 0);
    }
  },
    methods: {
      confirmPinLocation() {
        // Use the latest lat/lng and address from the pin
        if (this.lat && this.lng && this.address) {
          this.cartAddress = this.address; // Save the address
          this.saveCartAddress(); // Persist if needed
          this.closeModal('LocationPickerModal');
          this.$toast && this.$toast.success('Location selected!');
        } else {
          this.$toast && this.$toast.error('Please select a location on the map.');
        }
      },
    confirmLocation() {
      this.cartAddress = this.searchQuery; // Save the address separately
      this.closeModal('LocationPickerModal');
      this.saveCartAddress(); // Optional, only if you persist it
    },
    saveCartAddress() {
      localStorage.setItem('cartAddress', this.cartAddress);
    },
    selectSuggestion(suggestion) {
      this.searchQuery = suggestion.description;
      this.address = suggestion.description;
      this.predictions = [];
    },
      openModal(id) {
        const modalElement = document.getElementById(id);
        if (modalElement) {
          modalElement.classList.add('show');
          modalElement.style.display = 'block';
          document.body.classList.add('modal-open');
        }
      },
      closeModal(id) {
        const modalElement = document.getElementById(id);
        modalElement.classList.remove('show'); // Remove the 'show' class
        modalElement.style.display = 'none'; // Hide the modal
        document.body.classList.remove('modal-open'); // Allow background scrolling

        // Remove the backdrop if it exists
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.parentNode.removeChild(backdrop);
        }
      },
      async handleInput() {
        if (this.searchQuery.trim().length > 1) {
          const result = await this.searchPlaces(this.searchQuery);
          if (result && result.predictions) {
            this.predictions = result.predictions;
          }
        } else {
          this.predictions = []; // Clear predictions when input is empty
        }
      },
    async searchPlaces(query) {
      try {
        const response = await this.$axios.post("/search-places", { query });
        // console.log('response', response);
        return response.data;
      } catch (error) {
        console.error('Error fetching places:', error);
        return null;
      }
    },
  showMapModal() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  initMap() {
  this.openModal('LocationPickerModal');
  if (window.google && document.getElementById('map')) {
    const defaultLatLng = { lat: 25.2048, lng: 55.2708 };
    this.map = new google.maps.Map(document.getElementById('map'), {
      center: defaultLatLng,
      zoom: 12,
    });
    this.marker = new google.maps.Marker({
      position: defaultLatLng,
      map: this.map,
      draggable: true,
    });
    // Update lat/lng when marker is dragged
    this.marker.addListener('dragend', (event) => {
      this.locationConfirmed = true;
      this.lat = event.latLng.lat();
      this.lng = event.latLng.lng();
      this.reverseGeocodePin(this.lat, this.lng);
    });

    // Optional: Move marker on map click
    this.map.addListener('click', (event) => {
      this.marker.setPosition(event.latLng);
      this.lat = event.latLng.lat();
      this.lng = event.latLng.lng();
      this.reverseGeocodePin(this.lat, this.lng);
       this.locationConfirmed = true;
    });
    this.map.addListener('dragend', () => {
      const center = this.map.getCenter();
      this.marker.setPosition(center); // Optional: re-center the marker
      this.lat = center.lat();
      this.lng = center.lng();
      this.locationConfirmed = true;
      this.reverseGeocodePin(this.lat, this.lng);
    });
  }
},
async reverseGeocodePin(lat, lng) {
   const geocoder = new google.maps.Geocoder();
  const latLng = { lat: parseFloat(lat), lng: parseFloat(lng) };

  geocoder.geocode({ location: latLng }, (results, status) => {
    if (status === "OK") {
      if (results[0]) {
        // console.log("Location name:", results[0].formatted_address);
        this.address = results[0].formatted_address; 
      } else {
        console.error("No results found");
      }
    } else {
      console.error("Geocoder failed due to:", status);
    }
  });
},
    checkCartAndProceed() {
      if (!this.cart || this.cart.length === 0) {
        this.$toast.error('Please, Select the service first.');
      } else {
        this.$router.push('/date');
        window.scrollTo(0, 0); 
      }
    },
    addToCart(service) {
      // console.log('service add to cart', service);
    // Check if the service is already in the cart
    const serviceExists = this.cart.find((item) => item.id === service.id);

    if (serviceExists) {
      serviceExists.count++;
      // alert('This service is already in your cart.');
    } else {
      this.cart.push({...service, count: 1}); // Add the service to the cart
    // console.log('this.cart', this.cart);

      // alert(`${service.name} has been added to the cart!`);
    }
    this.saveCart();
  },
  removeItem(index) {
    this.cart.splice(index, 1); // Remove the item at the specified index
    this.saveCart(); // Save updated cart to localStorage
  },
  saveCart() {
    localStorage.setItem('cart', JSON.stringify(this.cart));
  },

  // Load the cart from localStorage
  loadCart() {
    const cartData = localStorage.getItem('cart');
    if (cartData) {
      this.cart = JSON.parse(cartData); // Parse and assign the cart data to the cart
    }
    const cartAddressData = localStorage.getItem('cartAddress');
    if (cartAddressData) {
      this.cartAddress = cartAddressData; // Parse and assign the cart data to the cart
    }
    if (this.cartAddress === '') {
      this.showMapModal();
    }else{
      this.address = this.cartAddress;
    }
  },
  // Method to increase the count of an item in the cart
  increment(id) {
    const item = this.cart.find((cartItem) => cartItem.id === id);
    if (item) {
      item.count++;
      this.saveCart();

    }
  },
  decrement(id) {
    const item = this.cart.find((cartItem) => cartItem.id === id);
    if (item && item.count > 1) {
      item.count--;
      this.saveCart();
    } else if (item && item.count === 1) {
      this.cart = this.cart.filter((cartItem) => cartItem.id !== id);
      this.saveCart();
    }
  },
  isInCart(id) {
    return this.cart.some((item) => item.id === id);
  },
  getCartItem(id) {
    return this.cart.find((item) => item.id === id) || {};
  },
  fetchDataAndOpenModal(id) {
  this.loading = true;
  this.error = null;

  // Open the modal programmatically using plain JavaScript
  const modalElement = document.getElementById('AddToCArtModal');
  modalElement.classList.add('show'); // Add the 'show' class
  modalElement.style.display = 'block'; // Make it visible
  document.body.classList.add('modal-open'); // Prevent background scrolling

  // Axios request to fetch data
  this.$axios
    .post('/get-services', {
      id: id, // Include website name in the request body
    })
    .then((response) => {
      this.services = response.data.planDetailData; // Update services data
      this.modalData = response.data.SelectedPlanDetailPrices; // Update services data
    })
    .catch((error) => {
      this.error = 'Failed to fetch services. Please try again.';
      console.error(error);
    })
    .finally(() => {
      this.loading = false; // Stop loading indicator
    });
},

      async fetchCategories() {
  try {
    // Send a POST request with the website name in the body
    const response = await this.$axios.post('/get-categories', {
      website_name: this.$websiteName,  // Include website name in the request body
    });

    if (response.data.status === "success") {
      // console.log('response data category', response);
      this.categories = response.data.categories;
      this.planDetails = response.data.planDetails;
      this.plans = response.data.plans;
      this.selectedPlanId = '';
      this.selectedCategoryId = 'all';
      this.planDetailsArray = this.planDetails;
     
    } else {
      console.error("Failed to fetch categories:", response.data);
    }
  } catch (error) {
    console.error('Error fetching categories:', error);
  }
},
// closeModal() {
//   const modalElement = document.getElementById('AddToCArtModal');
//   modalElement.classList.remove('show'); 
//   modalElement.style.display = 'none'; 
//   document.body.classList.remove('modal-open'); 
//   // Remove the backdrop if it exists
//   const backdrop = document.querySelector('.modal-backdrop');
//   if (backdrop) {
//     backdrop.parentNode.removeChild(backdrop);
//   }
// },
      setActiveLink(link) {
        this.activeLink = link;
      },
      filterPlans(plan_id) {
        this.selectedPlanId = plan_id;
        if (this.selectedCategoryId === 'all') {
          this.planDetailsArray = this.planDetails.filter(item => item.plan_id === this.selectedPlanId);
        } 
        else {
          this.planDetailsArray = this.planDetails.filter(item =>
            item.plan_id === this.selectedPlanId && item.category_id === this.selectedCategoryId
          );
        }
      },
      filterCategories(category_id) {
        this.selectedCategoryId = category_id;

        if (category_id === 'all' && this.selectedPlanId !== '') {
          this.planDetailsArray = this.planDetails.filter(item => item.plan_id === this.selectedPlanId);
        
        } else if (category_id === 'all' && this.selectedPlanId === '') {
          this.planDetailsArray = this.planDetails;
        } else if (category_id !== 'all' && this.selectedPlanId === '') {
          this.planDetailsArray = this.planDetails.filter(item => item.category_id === category_id);
        } else {
          this.planDetailsArray = this.planDetails.filter(item => 
            item.plan_id === this.selectedPlanId && item.category_id === category_id
          );
        }
      },
      
    },
  };
</script>

<style scoped></style>
